type BadgeColor =
  | 'primary'
  | 'teal'
  | 'red'
  | 'green'
  | 'yellow'
  | 'orange'
  | 'purple'
  | 'blue'
  | 'gray'

const COLOR_CLASSES: Record<BadgeColor, string> = {
  primary: 'bg-button-primary text-white',
  teal: 'bg-teal-600 text-white',
  red: 'bg-red-50 text-red-600',
  green: 'bg-green-100 text-green-700',
  yellow: 'bg-yellow-100 text-yellow-800',
  orange: 'bg-orange-100 text-orange-700',
  purple: 'bg-purple-100 text-purple-700',
  blue: 'bg-blue-100 text-blue-700',
  gray: 'bg-gray-100 text-gray-600',
}

type BadgeProps = {
  children: React.ReactNode
  color?: BadgeColor
  className?: string
}

const Badge = ({ children, color = 'primary', className = '' }: BadgeProps) => (
  <span
    className={`inline-flex shrink-0 items-center rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${COLOR_CLASSES[color]} ${className}`}
  >
    {children}
  </span>
)

export default Badge
